import Footer from "../components/Footer";
import Header from "../components/Header";

const UuDaiTaiChinh = () => {
  return (
    <div className="wrapper">
      <div className="container-web uudaitaichinh bgnew">
        <Header title="Ưu đãi tài chính" />

        <main className="px-3">
          <p>
            Trái phiếu tiết kiệm có thể mang lại nhiều lợi ích hấp dẫn nếu bạn
            đang tìm cách đầu tư và tích lũy tài sản. Theo như mong muốn của ban
            lãnh đạo HĐQT tập đoàn dành cho việc tri ân các cán bộ công nhân
            viên cấp cao gắn bó thâm niên cùng với các đối tác lâu năm, lợi
            nhuận tiềm năng từ việc gửi trái phiếu tiết kiệm cung cấp tối ưu hóa
            dòng vốn. Khi tham gia trái phiếu tiết kiệm còn giúp gia tăng giá
            trị đầu tư của bạn, đặc biệt kết hợp với các ưu đãi và chương trình
            khuyến mãi. Với những phần thưởng hấp dẫn và tỷ lệ lợi nhuận tiềm
            năng cao. Việc gửi tiết kiệm vào trái phiếu tiết kiệm của tập đoàn
            có thể giúp bạn tạo dựng một nền tảng tài chính vững chắc cho hiện
            tại và tương lai sau này.
          </p>

          <p>
            Ngoài ra: Tập đoàn đang triển khai chương trình ưu đãi hỗ trợ cho
            quý khách hàng tham gia gửi trái phiếu tiết kiệm 1 phần quà giảm giá
            từ 20-50% bao gồm tất cả sản phẩm trang sức vàng bạc đá quý trên
            trang chủ của tập đoàn :{" "}
            <a
              style={{ color: "#2880b9", textDecoration: "none" }}
              href="https://trangsuc.doji.vn/"
            >
              https://trangsuc.doji.vn/
            </a>{" "}
            <span style={{ color: "#e74c3c" }}>
              (Lưu ý: Chương trình chỉ hỗ trợ trong trường hợp quý khách quy đổi
              từ tiền thưởng và lợi nhuận trái phiếu sang các sản phẩm trang sức
              của tập đoàn)
            </span>
          </p>

          <div className="border-top">
            <div style={{ border: "2px solid #deaa4f" }}>
              <table className="table text-center">
                <tbody>
                  <tr className="heading">
                    <td colSpan={3}>PHÚC LỢI THÀNH VIÊN CƠ BẢN</td>
                  </tr>
                  <tr>
                    <td>Loại</td>
                    <td>Tiền Thưởng</td>
                    <td>Lợi Nhuận</td>
                  </tr>

                  <tr>
                    <td>50 Triệu</td>
                    <td>3 Triệu</td>
                    <td>0.4%</td>
                  </tr>

                  <tr>
                    <td>200 Triệu</td>
                    <td>12 Triệu</td>
                    <td>0.5%</td>
                  </tr>

                  <tr>
                    <td>300 Triệu</td>
                    <td>18 Triệu</td>
                    <td>0.6%</td>
                  </tr>

                  <tr>
                    <td>500 Triệu</td>
                    <td>35 Triệu</td>
                    <td>0.7%</td>
                  </tr>

                  <tr>
                    <td colSpan={3}>
                      TRÁI PHIẾU TIẾT KIỆM LÀ CHƯƠNG TRÌNH KHÁCH HÀNG THÂN THIẾT
                      ĐỘC QUYỀN DÀNH CHO QUẢN LÝ CẤP CAO CỦA TẬP ĐOÀN VÀ ĐỐI TÁC
                      THÂN THIẾT. TRÁI PHIẾU TIẾT KIỆM MANG ĐẾN ƯU ĐÃI TÀI CHÍNH
                      HẤP DẪN VÀ ƯU ĐÃI PHÚC LỢI ĐẲNG CẤP CHO CÁC THÀNH VIÊN
                      ĐĂNG KÝ THAM GIA.
                    </td>
                  </tr>

                  <tr className="heading">
                    <td colSpan={3}>PHÚC LỢI THÀNH VIÊN CAO CẤP</td>
                  </tr>

                  <tr>
                    <td>800 Triệu</td>
                    <td>64 Triệu</td>
                    <td>0.9%</td>
                  </tr>

                  <tr>
                    <td>1.5 Tỷ</td>
                    <td>120 Triệu</td>
                    <td>1.1%</td>
                  </tr>

                  <tr>
                    <td>3 Tỷ</td>
                    <td>240 Triệu</td>
                    <td>1.3%</td>
                  </tr>
                  <tr>
                    <td>7 Tỷ</td>
                    <td>600 Triệu</td>
                    <td>1.5%</td>
                  </tr>
                  <tr>
                    <td>16 Tỷ</td>
                    <td>1 Tỷ 400 Triệu</td>
                    <td>1.7%</td>
                  </tr>
                  <tr>
                    <td>25 Tỷ</td>
                    <td>2 Tỷ 250 Triệu</td>
                    <td>1.9%</td>
                  </tr>
                  <tr>
                    <td>40 Tỷ</td>
                    <td>3 Tỷ 680 Triệu</td>
                    <td>2.1%</td>
                  </tr>
                  <tr>
                    <td>60 Tỷ</td>
                    <td>5 Tỷ 700 Triệu</td>
                    <td>2.4%</td>
                  </tr>
                  <tr>
                    <td>90 Tỷ</td>
                    <td>8 Tỷ 820 Triệu</td>
                    <td>2.7%</td>
                  </tr>
                  <tr>
                    <td>150 Tỷ</td>
                    <td>15 Tỷ</td>
                    <td>3.0%</td>
                  </tr>
                  <tr>
                    <td colSpan={3}>
                      CHƯƠNG TRÌNH THAM GIA ĐẶT LỊCH CÓ QUY ĐỊNH THỜI GIAN HOẠT
                      ĐỘNG, SAU KHI ĐẶT LỊCH QUÝ KHÁCH CẦN HOÀN THÀNH ĐÚNG THỜI
                      GIAN QUY ĐỊNH. TRÂN TRỌNG CẢM ƠN !
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div style={{ paddingBottom: 120 }}></div>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default UuDaiTaiChinh;
